import { createGroup } from './groupFactory'
import { createTileLayer } from './tileFactory'
import { createVectorLayer } from './vectorFactory'
import { createVectorTileLayer } from './VectorTileFactory'
import { createWmsLayer } from './wmsFactory'
import { createWmtsLayer } from './wmtsFactory'

export function createLayer(config) {
  switch (config.type) {
    case 'group':
      return createGroup(config)

    case 'osm':
    case 'stadia':
    case 'tilejson':
    case 'xyz':
      return createTileLayer(config)

    case 'wms':
    case 'arcgisrest':
      return createWmsLayer(config)

    case 'geojson':
    case 'wfs':
    case 'esriFeature':
    case 'kml':
      return createVectorLayer(config)

    case 'mapboxStyle':
      return createVectorTileLayer(config)

    case 'wmts':
      return createWmtsLayer(config)

    default:
      throw new Error(`Unknown layer type: ${config.type}`)
  }
}
